import { createRouter, createWebHistory } from 'vue-router'
import { Routes } from '@/router/routes'
import { RouterContexts } from '@/router/RouterContexts'
import { vehiclesRoutes } from '@/router/contexts/portal/modules/vehicles'
import { trainingRoutes } from '@/router/contexts/portal/modules/training'
import { timesheetRoutes } from '@/router/contexts/portal/modules/timesheets'
import { staffRoutes } from '@/router/contexts/portal/modules/staff'
import { scheduleRoutes } from '@/router/contexts/portal/modules/schedule'
import { operationalBasesRoutes } from '@/router/contexts/portal/modules/operational-bases'
import { notificationsRoutes } from '@/router/contexts/portal/modules/notifications'
import { metricsRoutes } from '@/router/contexts/portal/modules/metrics'
import { mapsRoutes } from '@/router/contexts/portal/modules/maps'
import { knowledgeHubRoutes } from '@/router/contexts/portal/modules/knowledge-hub'
import { incidentsRoutes } from '@/router/contexts/portal/modules/incidents'
import { holidayRequestsRoutes } from '@/router/contexts/portal/modules/holiday-requests'
import { hoeysRoutes } from '@/router/contexts/portal/modules/hoeys'
import { fleetRoutes } from '@/router/contexts/portal/modules/fleet'
import { feedbackRoutes } from '@/router/contexts/portal/modules/feedback'
import { experiencesRoutes } from '@/router/contexts/portal/modules/experiences'
import { errorRoutes } from '@/router/contexts/portal/modules/error'
import { eodReportRoutes } from '@/router/contexts/portal/modules/eod-report'
import { deviationsRoutes } from '@/router/contexts/portal/modules/deviations'
import { departmentRoutes } from '@/router/contexts/portal/modules/department'
import { dashboardRoutes } from '@/router/contexts/portal/modules/dashboard'
import { dailySummaryRoutes } from '@/router/contexts/portal/modules/daily-summary'
import { dailyAgendaRoutes } from '@/router/contexts/portal/modules/daily-agenda'
import { dailyAgendaV2Routes } from '@/router/contexts/portal/modules/daily-agenda-v2'
import { customEventsRoutes } from '@/router/contexts/portal/modules/custom-events'
// Import route modules
import { authRoutes } from '@/router/contexts/portal/modules/auth'
import { assessmentsRoutes } from '@/router/contexts/portal/modules/assessments'
import { alertsRoutes } from '@/router/contexts/portal/modules/alerts'

import { Middleware } from '@/types/enums/middleware/middleware'

// Define the layout route that will contain most child routes
const layoutRoute = {
  path: '/',
  name: 'layout',
  component: () => import('@/components/layout/DefaultLayout.vue'),
  meta: {
    middleware: [Middleware.REQUIRES_AUTH],
    routerContexts: [RouterContexts.PORTAL_CONTEXT],
  },
  redirect: { name: 'dashboard' },
  children: [
    ...errorRoutes.filter(route => route.name === Routes.Forbidden),
    ...dashboardRoutes,
    ...timesheetRoutes,
    ...staffRoutes,
    ...scheduleRoutes,
    ...alertsRoutes,
    ...dailyAgendaRoutes,
    ...dailyAgendaV2Routes,
    ...dailySummaryRoutes,
    ...eodReportRoutes,
    ...deviationsRoutes,
    ...hoeysRoutes,
    ...notificationsRoutes,
    ...holidayRequestsRoutes,
    ...incidentsRoutes,
    ...metricsRoutes,
    ...knowledgeHubRoutes,
    ...departmentRoutes,
    ...experiencesRoutes,
    ...assessmentsRoutes,
    ...trainingRoutes,
    ...customEventsRoutes,
    ...feedbackRoutes,
    ...vehiclesRoutes,
    ...operationalBasesRoutes,
    ...fleetRoutes,
  ],
}

// Define the layout route that will contain most child routes
const dailyAgendaAppLayoutRoute = {
  path: '/daily-agenda-layout',
  name: 'daily-agenda-layout',
  component: () => import('@/components/layout/daily-agenda-app/DailyAgendaAppLayout.vue'),
  meta: {
    middleware: [Middleware.REQUIRES_AUTH],
    routerContexts: [RouterContexts.DAILY_AGENDA_CONTEXT],
  },
  redirect: { name: 'daily-agenda-dashboard' },
  children: [
    ...errorRoutes.filter(route => route.name === Routes.Forbidden),
    {
      path: '/dashboard',
      name: 'daily-agenda-dashboard',
      component: () => import('@/pages/contexts/daily-agenda/Index.vue'),
      meta: {
        middleware: [
          Middleware.REQUIRES_AUTH,
        ],
      },
    },
  ],
}

// Combine all routes
export const routes = [
  ...authRoutes,
  layoutRoute,
  dailyAgendaAppLayoutRoute,
  ...mapsRoutes,
  ...errorRoutes.filter(route => route.name === Routes.NotFound),
]

export const router = createRouter({
  // In the Laravel app, Vite's BASE_URL points to the asset build directory.
  // The SPA itself is served from the site root, so router history must not
  // inherit the `/build` asset prefix.
  history: createWebHistory('/'),
  routes,
})
